import React, { useState } from "react";
import {
  Create,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useNotify,
  useRedirect,
} from "react-admin";
import { API, graphqlOperation } from "aws-amplify";
import { useForm } from "react-final-form";
import { logError } from "../../../utils/appUtils";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { helpPageByUrl } from "../../../graphql/queries";
import { FilePaths } from "../../../utils/constants";
import {
  saveHelpPageContentFile,
  saveRemoveFiles,
} from "../../../utils/fileUtils";
import { HelpPageForm } from "./HelpPageForm";

const CreateActions = (props) => (
  <TopToolbar>
    <HelpButton />
    <BackButton {...props} />
  </TopToolbar>
);

const CreateToolbar = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const form = useForm();
  const [saving, setSaving] = useState(false);

  const onSave = async (data) => {
    const formState = form.getState();
    const url = formState?.values?.url;

    try {
      const input = { active: "true", url: { eq: url }, limit: 100 };
      const response = await API.graphql(
        graphqlOperation(helpPageByUrl, input)
      );
      const helpPageData = response.data?.helpPageByUrl?.items;
      if (helpPageData.length > 0) {
        setSaving(false);
        notify("A Help Page with this URL already exists", "warning");
        return;
      } else {
        props.handleSubmit();
      }
    } catch (error) {
      setSaving(false);
      logError("helpPages:HelpPageCreate:transform", error, notify);
      return;
    }
  };

  const transform = async (data) => {
    setSaving(true);
    const newData = {
      ...data,
      active: "true",
      updatedBy: window.appUser?.fullName,
    };

    try {
      if (newData.kbFiles?.length > 0) {
        await saveRemoveFiles(
          undefined,
          newData,
          "kbFiles",
          `${FilePaths.KB_FILES}/${newData.topic}`
        );
      }
      if (newData.kbMedia?.length > 0) {
        await saveRemoveFiles(
          undefined,
          newData,
          "kbMedia",
          `${FilePaths.KB_MEDIA}/${newData.topic}`
        );
      }
      await saveHelpPageContentFile(undefined, newData);
    } catch (error) {
      setSaving(false);
      logError("helpPages:HelpPageCreate:transform", error, notify);
      return Promise.reject(error);
    }

    return newData;
  };

  const onSuccess = () => {
    setSaving(false);
    notify("Help Page created successfully", "success");
    redirect("list", "/helpPages");
  };

  const onFailure = (error) => {
    setSaving(false);
    notify("Failed to create Help Page", "error");
    logError("helpPages:HelpPageCreate:onFailure", error, notify);
  };

  return (
    <Toolbar {...props} saving={saving}>
      <SaveButton
        id="saveHelp"
        label="Save"
        transform={transform}
        onSuccess={onSuccess}
        onFailure={onFailure}
        handleSubmitWithRedirect={onSave}
      />
    </Toolbar>
  );
};

export const HelpPageCreate = (props) => {
  const cloneRecord = props.location?.state?.clone || {};
  const initValues = {
    ...cloneRecord,
  };
  delete initValues.id;
  delete initValues.url;
  delete initValues.updatedAt;
  delete initValues.createdAt;
  return (
    <Create
      {...props}
      title={<ForceTitle title="Create Help Page" />}
      actions={<CreateActions {...props} />}
    >
      <SimpleForm
        initialValues={initValues}
        submitOnEnter={false}
        toolbar={<CreateToolbar {...props} />}
      >
        <HelpPageForm {...props} />
      </SimpleForm>
    </Create>
  );
};
